import { format } from "date-fns";
import { CommandXFooter } from "./CommandXFooter";

const fmt = (n: number) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);

interface KPI {
  label: string;
  value: string;
}

interface ProjectSummaryPrintData {
  name: string;
  project_number?: string | null;
  status: string;
  customer_name?: string;
  city?: string | null;
  state?: string | null;
  company_name?: string;
  company_logo_url?: string | null;
  created_at: string;
  kpis?: KPI[];
}

export const ProjectSummaryPrintTemplate = ({ data }: { data: ProjectSummaryPrintData }) => {
  const location = [data.city, data.state].filter(Boolean).join(", ");

  return (
    <div className="print-template p-8 max-w-[8.5in] mx-auto font-sans text-sm leading-relaxed">
      <div className="flex justify-between items-start border-b pb-4 mb-6">
        <div>
          {data.company_logo_url && (
            <img src={data.company_logo_url} alt={data.company_name ?? "Company"} style={{ maxHeight: "40px", objectFit: "contain", marginBottom: "4px" }} />
          )}
          <h1 className="text-2xl font-bold tracking-tight" style={{ color: "#111" }}>PROJECT SUMMARY</h1>
          {data.company_name && (
            <p className="text-base font-medium mt-1" style={{ color: "#333" }}>{data.company_name}</p>
          )}
        </div>
        <div className="text-right">
          {data.project_number && (
            <p className="text-lg font-bold font-mono" style={{ color: "#111" }}>{data.project_number}</p>
          )}
          <p className="mt-1 inline-block px-2 py-0.5 rounded text-xs font-semibold uppercase" style={{ background: "#f3f4f6", color: "#374151" }}>
            {data.status}
          </p>
        </div>
      </div>

      <div className="mb-6">
        <h2 className="text-xl font-bold mb-4" style={{ color: "#111" }}>{data.name}</h2>
        <div className="grid grid-cols-3 gap-6">
          <div>
            <p className="text-xs uppercase tracking-wider font-semibold mb-1" style={{ color: "#999" }}>Customer</p>
            <p className="font-medium">{data.customer_name || "—"}</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider font-semibold mb-1" style={{ color: "#999" }}>Location</p>
            <p className="font-medium">{location || "—"}</p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-wider font-semibold mb-1" style={{ color: "#999" }}>Created</p>
            <p className="font-medium">{format(new Date(data.created_at), "MMMM d, yyyy")}</p>
          </div>
        </div>
      </div>

      {/* KPI Cards */}
      {data.kpis && data.kpis.length > 0 && (
        <div className="mb-8">
          <p className="text-xs uppercase tracking-wider font-semibold mb-3" style={{ color: "#999" }}>Key Metrics</p>
          <div className="grid grid-cols-3 gap-4">
            {data.kpis.map((kpi, i) => (
              <div key={i} className="p-4 rounded" style={{ border: "1px solid #e5e7eb", background: "#fafafa" }}>
                <p className="text-xs" style={{ color: "#666" }}>{kpi.label}</p>
                <p className="text-lg font-bold mt-1" style={{ color: "#111" }}>{kpi.value}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      <CommandXFooter />
    </div>
  );
};
